import Cookies from 'js-cookie';
function init() {
  document.addEventListener('DOMContentLoaded', async () => {
    const priceEl = document.querySelector('.rlx-model-cover__price');

    const country = await checkCountry();

    if (
      country === 'CA' &&
      priceEl.getAttribute('data-price') !== 'undefined'
    ) {
      // console.debug('Showing price');
      priceEl.style.display = 'flex';
    }
  });
}

async function checkCountry() {
  let countryCode = Cookies.get('raffi_countrycode')
    ? Cookies.get('raffi_countrycode')
    : undefined;

  if (!countryCode) {
    countryCode = await getCountryCode();
  }

  if (countryCode !== null) {
    Cookies.set('raffi_countrycode', countryCode, { expires: 30 });
  }

  return countryCode;
}

async function getCountryCode() {
  try {
    const request = await fetch(
      'https://extreme-ip-lookup.com/json/?key=rG6pSmSugfhE4IhyUFLL',
      {}
    );
    const response = await request.json();

    return response.countryCode;
  } catch (error) {
    console.error(error);

    return null;
  }
}

init();
